<template>
	<g id="cat_cont">
		<image id="cat" width="300" height="180"  v-bind="{'xlink:href':cat1}" v-on:mouseover="mouseOver" transform="matrix(0.4448 0 0 0.4448 609.8432 697.8701)"></image>
	</g>
</template>
<script>

import cat_sleeping from './../../assets/img/cat_sleeping.gif'
import cat_react from './../../assets/img/cat_react.gif'

export default {
	name: 'cat',
	data () {
		return {
			cat1 : cat_sleeping,
			cat_sleeping: true
		}
	},
	methods: { 
		mouseOver: function() {
			if(this.cat_sleeping){
	  			this.cat1 = cat_react;
	  			this.cat_sleeping = false;
	  			setTimeout( () => { 
					this.cat_sleeping = true;
					this.cat1 = cat_sleeping;
			 	}, 2000);
  			}
		}
	},
	mounted: function () {
	}
}	
</script>



// WEBPACK FOOTER //
// Cat.vue?0873ddba